module.exports = __webpack_public_path__ + "img/ewm.040d00a0.png";